import React from 'react';
import { View, ScrollView } from 'react-native';
import { connect } from 'react-redux';
import queryString from "query-string";

import { fetchJourneyAndUserProgress } from "../../redux/actions";

import Colors from "../../constants/Colors";

import { SpinnerControl } from "../../components";
import JourneyElementsAccessCard from "./cards/JourneyElementsAccessCard";
import JourneyActivitiesDeliveryCard from "./cards/JourneyActivitiesDeliveryCard";
import JourneyRatingCard from "./cards/JourneyRatingCard";
import NavBar from "../../components/NavBar";
import CompleteJourneyModal from "./modals/CompleteJourneyModal";

class JourneyHubScreen extends React.Component {

    static navigationOptions = ({navigation}) => {
        return null;
    };

    state = {
        canCompleteJourney: false,
        journeyIsComplete: false,
    }

    checkIfCanComplete = async () => {

        const values = queryString.parse(this.props.location.search);
        const journeyId = values.journeyId;

        await this.props.fetchJourneyAndUserProgress(journeyId);

        const { currentJourney, currentUserProgress } = this.props;
        this.setState({ canCompleteJourney: false })
        if (currentJourney !== null && currentUserProgress !== null) {
            if (currentJourney.items.length === currentUserProgress.progress.length) {
                this.setState({ journeyIsComplete: true })
                if (currentUserProgress.isCollected === false) {
                    this.setState({ canCompleteJourney: true })
                }
            }
        }
    }

    componentDidMount() {
        this.checkIfCanComplete();
    }

    render() {

        const values = queryString.parse(this.props.location.search);
        const journeyId = values.journeyId;

        const title = this.props.currentJourney === null ? "" : this.props.currentJourney.title;

        return (
            <NavBar title={`${title}`}>

                <CompleteJourneyModal
                    isVisible={this.state.canCompleteJourney}
                    onComplete={() => {
                        this.setState({ canCompleteJourney: false })
                        this.props.history.push('/journeys/completed')
                    }}
                />

                <SpinnerControl
                    isFetching={this.props.fetchingCurrentJourneyUserProgress}
                    textPropsStyle={{ color: Colors.spinnerNoBackgroundTextColor }}
                    text={"Carregando!"}
                />

                {
                    this.props.currentJourney !== null &&
                        <View style={{ width: 400 }}>
                            <JourneyElementsAccessCard journeyId={journeyId} />
                            <JourneyActivitiesDeliveryCard
                                journeyId={journeyId}
                                forumEnabled={this.props.currentJourney.forumEnabled}
                                applicationEnabled={this.props.currentJourney.applicationEnabled}
                            />

                            <JourneyRatingCard />

                        </View>
                }

            </NavBar>
        )
    }
}

const mapStateToProps = state => {
    return {
        fetchingCurrentJourneyUserProgress: state.journey.fetchingCurrentJourneyUserProgress,
        currentJourney: state.journey.currentJourney,
        currentUserProgress: state.journey.currentUserProgress,
    }
}

export default connect(mapStateToProps, { fetchJourneyAndUserProgress })(JourneyHubScreen);
